<script setup lang="ts">
defineProps<{
  type?: string
  label: string
  name: string
  pattern?: string
  placeholder?: string
  required?: boolean
}>()
</script>

<template>
  <div class="flex flex-col gap-2 font-mono text-sm uppercase">
    <label :for="name + label">
      <span>{{ label }} ({{ required ? 'Required' : 'Optional' }})</span>
    </label>

    <input
      :id="name + label"
      :required="required"
      :name="name"
      :placeholder="placeholder"
      class="selection:!text-neon-yellow border border-black/50 p-3 selection:!bg-black"
      :type="type || 'text'"
    />
  </div>
</template>
